import useSnackbarStore from '../store/snackbar';

/**
 * api:
 * This function is used to handle fetching data from the server
 * It takes the request and the options for the fetch
 * It returns the data and the error
 *
 * Using $fetch to make network requests based on user interaction.
 *
 * @param {NitroFetchRequest} request: The request to fetch the data
 * @param {NitroFetchOptions} opts: The options for the fetch
 * @returns {pending, data, error, execute}
 */
export default defineNuxtPlugin(() => {
  const snackbar = useSnackbarStore();
  const requestHeaders: HeadersInit = new Headers();
  requestHeaders.set('Content-Type', 'application/json; charset=utf-8');

  const $api = $fetch.create({
    baseURL: useRuntimeConfig().public.apiURL,
    headers: {
      Accept: 'application/json',
    },
    onRequest({ request, options }) {
      const guestRoutes = ['/auth/login', '/auth/register', '/auth/forgot-password', '/auth/reset-password'];
      const isGuestRoute = guestRoutes.some((route) => request.toString().includes(route));

      if (isGuestRoute) return;

      const accessToken = useCookie(useRuntimeConfig().public.auth?.provider?.token?.cookieName || 'accessToken');
      if (accessToken.value) {
        options.headers = new Headers(options.headers || {});
        options.headers.set('Authorization', `Bearer ${accessToken.value}`);
      }
    },
    async onResponseError({ response }) {
      if (response.status === 401 && response._data?.error_code === 'HTTP_UNAUTHORIZED') {
        // Unauthorized - likely due to invalid/expired token, so we clear it and redirect to login
        window.location.href = '/';
        return;
      }

      if (response.status === 401 && response._data?.error_code === 'USERNAME_NOT_FOUND') {
        return;
      }

      snackbar.showSnackbar({
        text: response._data.message,
        state: false,
      });
    },
  });

  return {
    provide: {
      api: $api,
    },
  };
});
